import React from 'react'

import Hero from '../components/Hero.js'
import PokemonList from '../components/PokemonList.js'

export default function Pokedex() {
      return (
            <div>
                  <Hero />
                  <PokemonList />
            </div>
      )
}
